import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import './AmexGDALearnMore.scss';

const AmexGDALearnMore = (props) => {
  const {
    animationPlay, animationPlayed, pageContentByLanguage, printContent, sectionLearn, matchMedia, baseRequestUrl, animationState: ANIMATION_STATE,
  } = props;

  const {
    learnHeadline, learnBlurb, learn1Headline, learn1Paragraph1, learn1Paragraph2,
    learn2Headline, learn2Paragraph1, learnMoreImage,
  } = pageContentByLanguage;

  const imageMobileScreen = `${baseRequestUrl}GDA/images/${learnMoreImage}`;

  const contentBoxOne = () => (
    <>
      <h3 className="GDA__Learn__Text">{printContent(learn1Headline, 'learn1Headline')}</h3>
      <p className="GDA__Learn__Text">
        {printContent(learn1Paragraph1, 'learn1Paragraph1')}
        {printContent(learn1Paragraph2, 'learn1Paragraph2')}
      </p>
    </>
  );

  const contentBoxTwo = () => (
    <>
      <h3 className="GDA__Learn__Text">{printContent(learn2Headline, 'learn2Headline')}</h3>
      <p className="GDA__Learn__Text">{printContent(learn2Paragraph1, 'learn2Paragraph1')}</p>
    </>
  );

  const desktopContent = () => (
    <div className="GDA__Learn__Content">
      <div className="GDA__Learn__wrapper--text">
        <div
          id="leftLearnMore"
          className={cx('GDA__Learn__textwrapper', {
            'left-side': (animationPlay !== ANIMATION_STATE.NEVER_PLAY),
            'left-side-motion-sensitive': (animationPlay === ANIMATION_STATE.NEVER_PLAY || animationPlayed),
          })}
        >
          {contentBoxOne()}
        </div>
      </div>
      <div id="mobileLearnMore" tabIndex="-1" className="GDA__Learn__wrapper" ref={sectionLearn}>
        <img
          className={cx('GDA__Learn__wrapper-mobileImage', {
            larger: (animationPlay !== ANIMATION_STATE.NEVER_PLAY),
            enlarged: (animationPlay === ANIMATION_STATE.NEVER_PLAY || animationPlayed),
          })}
          src={imageMobileScreen}
          alt=""
        />
      </div>
      <div className="GDA__Learn__wrapper--text">
        <div
          id="rightLearnMore"
          className={cx('GDA__Learn__textwrapper', {
            'right-side': (animationPlay !== ANIMATION_STATE.NEVER_PLAY),
            'right-side-motion-sensitive': (animationPlay === ANIMATION_STATE.NEVER_PLAY || animationPlayed),
          })}
        >
          {contentBoxTwo()}
        </div>
      </div>
    </div>
  );

  const mobileContent = () => (
    <div id="mobileLearnMore" tabIndex="-1" className="GDA__Learn__wrapper" ref={sectionLearn}>
      <img
        className={cx('GDA__Learn__wrapper-mobileImage', {
          larger: (animationPlay !== ANIMATION_STATE.NEVER_PLAY),
          enlarged: (animationPlay === ANIMATION_STATE.NEVER_PLAY || animationPlayed),
        })}
        src={imageMobileScreen}
        alt=""
      />
      <div
        className="GDA__Learn__gridwrapper"
        // Scrollable region must have keyboard access WCAG 2.1 (A), WCAG 2.0 (A), WCAG 2.2 (A)
        tabIndex="0" // eslint-disable-line jsx-a11y/no-noninteractive-tabindex
      >
        <div className="GDA__Learn__textgrid">
          <div
            id="leftLearnMore"
            className="GDA__Learn__textwrapper"
          >
            {contentBoxOne()}
          </div>
          <div
            id="rightLearnMore"
            className="GDA__Learn__textwrapper"
          >
            {contentBoxTwo()}
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div className="GDA__Learn">
      <h2>{printContent(learnHeadline, 'learnHeadline')}</h2>
      <p className="GDA__Learn--blurb">{printContent(learnBlurb, 'learnBlurb')}</p>
      {matchMedia.lg && desktopContent()}
      {!matchMedia.lg && mobileContent()}
    </div>
  );
};

AmexGDALearnMore.propTypes = {
  animationPlay: PropTypes.string.isRequired,
  animationPlayed: PropTypes.bool.isRequired,
  pageContentByLanguage: PropTypes.shape({
    learnHeadline: PropTypes.string.isRequired,
    learnBlurb: PropTypes.string.isRequired,
    learn1Headline: PropTypes.string.isRequired,
    learn1Paragraph1: PropTypes.string.isRequired,
    learn1Paragraph2: PropTypes.string.isRequired,
    learn2Headline: PropTypes.string.isRequired,
    learn2Paragraph1: PropTypes.string.isRequired,
    learnMoreImage: PropTypes.string.isRequired,
  }).isRequired,
  printContent: PropTypes.func.isRequired,
  sectionLearn: PropTypes.shape({}).isRequired,
  matchMedia: PropTypes.shape({
    xs: PropTypes.bool,
    sm: PropTypes.bool,
    md: PropTypes.bool,
    lg: PropTypes.bool,
    ipadLandscape: PropTypes.bool,
    xl: PropTypes.bool,
  }).isRequired,
  baseRequestUrl: PropTypes.string.isRequired,
  animationState: PropTypes.shape({
    TO_PLAY: PropTypes.string,
    PLAYED: PropTypes.string,
    NEVER_PLAY: PropTypes.string,
  }).isRequired,
};

export default AmexGDALearnMore;
